import type {
    GetWorkOsInformation_workOs_sso_exemptUsers,
    GetWorkOsInformation_workOs_sso_nonExemptUsers,
    GetWorkOsInformation_workOs as WorkOs,
    GetWorkOsInformation_workOs_domainInfo as DomainInfo,
    GetRoles_roles as Role,
} from 'nutshell-graphql-types';

export type FormattedOption = {
    value: string;
    label: string;
};

export type User =
    | GetWorkOsInformation_workOs_sso_exemptUsers
    | GetWorkOsInformation_workOs_sso_nonExemptUsers;

export function formatUserIdsList(users?: Array<User | null | undefined> | null) {
    return users ? users.map((user) => user && user.id).filter(Boolean) : [];
}

export function formatUserList(users?: Array<User | null | undefined> | null) {
    if (!users) {
        return [];
    }

    const formattedUsers: Array<FormattedOption> = users.map((user) => ({
        value: user ? user.id : '',
        label: user ? user.name : '',
    }));

    return formattedUsers.sort((a: FormattedOption, b: FormattedOption): number => {
        if (a.label && b.label) {
            return a.label.localeCompare(b.label);
        }

        return 0;
    });
}

export function getNonDefaultRoles(roles: Role[], workOs: WorkOs): Array<FormattedOption> {
    let roleOptions: Array<FormattedOption> = roles.map((role) => ({
        label: role.name,
        value: role.id,
    }));

    if (workOs && workOs.directorySync && workOs.directorySync.defaultRole && roleOptions) {
        roleOptions = roleOptions.filter(
            (role) =>
                role &&
                workOs.directorySync.defaultRole &&
                role.value !== workOs.directorySync.defaultRole.id
        );
    }

    return roleOptions;
}

export function getDefaultRole(workOs: WorkOs): FormattedOption | null | undefined {
    if (workOs && workOs.directorySync && workOs.directorySync.defaultRole) {
        return {
            label: workOs.directorySync.defaultRole.name,
            value: workOs.directorySync.defaultRole.id,
        };
    }

    return null;
}

export function isUserExemptFromSso(userId: string, exemptUsers: string[]): boolean {
    return exemptUsers.includes(userId);
}

export function hasVerifiedDomain(domainInfo: DomainInfo): boolean {
    return domainInfo.domains.some((domain) => domain.isVerified);
}

export function getSingleSignOnCopy(
    isConfigured: boolean,
    hasAtLeastOneVerifiedDomain: boolean,
    organizationId?: string | null
): string {
    if (isConfigured) {
        return 'Single sign-on is on';
    } else if (organizationId && hasAtLeastOneVerifiedDomain) {
        return 'Test single sign-on via the Admin Portal to finish setup';
    } else if (organizationId && !hasAtLeastOneVerifiedDomain) {
        return 'Single sign-on configuration still requires a verified domain';
    } else {
        return 'Single sign-on is off';
    }
}
